export default __webpack_public_path__ + "static/media/calculator.55c2e960.png";